/**
 * mb-header.js — BASIS. Mango Butter
 * Resizable sticky navbar:
 *  - Scroll > 80px  → pill state (narrow, blurred, floating)
 *  - Scroll ≤ 80px  → full-width state
 *  - Hamburger toggle for mobile dropdown
 *  - Inline search expand/collapse
 */

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 80;

  function initNav(outer) {
    const navbar      = outer.querySelector('[data-mb-navbar]');
    const hamburger   = outer.querySelector('[data-mb-hamburger]');
    const mobileWrap  = outer.querySelector('[data-mb-mobile-wrap]');
    const searchToggle = outer.querySelector('[data-mb-search-toggle]');
    const searchBar   = outer.querySelector('[data-mb-search-bar]');
    const searchClose = outer.querySelector('[data-mb-search-close]');
    const searchInput = searchBar && searchBar.querySelector('input[type="search"]');

    if (!navbar) return;

    /* ── Pill on scroll ── */
    let ticking = false;
    let lastScrollY = 0;

    function onScroll() {
      lastScrollY = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(updateScrollState);
        ticking = true;
      }
    }

    function updateScrollState() {
      const scrolled = lastScrollY > SCROLL_THRESHOLD;
      navbar.classList.toggle('is-scrolled', scrolled);
      outer.closest('.mb-nav-section').classList.toggle('is-scrolled', scrolled);
      ticking = false;
    }

    // Set initial state
    updateScrollState();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ── Mobile hamburger ── */
    let mobileOpen = false;

    function openMobile() {
      mobileOpen = true;
      hamburger.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.setAttribute('aria-label', 'Close menu');
      mobileWrap && mobileWrap.classList.add('is-open');
      mobileWrap && mobileWrap.removeAttribute('aria-hidden');
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }

    function closeMobile() {
      mobileOpen = false;
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.setAttribute('aria-label', 'Open menu');
      mobileWrap && mobileWrap.classList.remove('is-open');
      mobileWrap && mobileWrap.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (hamburger && mobileWrap) {
      hamburger.addEventListener('click', () => {
        mobileOpen ? closeMobile() : openMobile();
      });

      // Close mobile menu when a link is clicked
      mobileWrap.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMobile);
      });
    }

    /* ── Close mobile on resize to desktop ── */
    const mq = window.matchMedia('(min-width: 1024px)');
    mq.addEventListener('change', (e) => {
      if (e.matches) closeMobile();
    });

    /* ── Inline search expand ── */
    function openSearch() {
      if (!searchBar) return;
      searchBar.classList.add('is-open');
      searchBar.removeAttribute('aria-hidden');
      searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
      // Small delay so animation is visible before focusing
      setTimeout(() => {
        if (searchInput) {
          searchInput.focus();
        }
      }, 80);
    }

    function closeSearch() {
      if (!searchBar) return;
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
      searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', () => {
        searchBar && searchBar.classList.contains('is-open')
          ? closeSearch()
          : openSearch();
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    // Escape key closes search or mobile menu
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (searchBar && searchBar.classList.contains('is-open')) {
          closeSearch();
        } else if (mobileOpen) {
          closeMobile();
        }
      }
    });

    /* ── Active link highlight (based on current URL) ── */
    const currentPath = window.location.pathname;
    outer.querySelectorAll('.mb-nav__link, .mb-nav__mobile-link').forEach((link) => {
      const href = link.getAttribute('href');
      if (href && href !== '/' && currentPath.startsWith(href)) {
        link.classList.add('is-active');
      }
    });

    /* ── Cleanup on Shopify section reload ── */
    document.addEventListener('shopify:section:unload', () => {
      window.removeEventListener('scroll', onScroll);
      document.body.style.overflow = '';
    }, { once: true });
  }

  /* ── Bootstrap ── */
  function boot() {
    document.querySelectorAll('[data-mb-nav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();
